export const bookingEntryStorageKey = "magistika.booking-entry.v1";
